<template>
    <HeaderComponent />
    <ScrollableView class="view-container" contentClass="orders-view"> </ScrollableView>
</template>

<script setup lang="ts">
    import { onBeforeUnmount, onMounted, ref } from "vue";

    import ScrollableView from "@/components/layout/ScrollableView.vue";
    import HeaderComponent from "@/operator/components/layout/HeaderComponent.vue";
    //
    // // state
    // const isLoading = ref(false);

    // define html refs

    // functions

    // register events
    onMounted(async () => {});

    onBeforeUnmount(() => {});
</script>

<style lang="scss">
    @use "./../../../assets/styles/scss/shared/_variables.scss";
    @use "./../../../assets/styles/scss/shared/_colors.scss";

    .app > .orders {
        > .scrollable {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 52px;

            > .tabulator {
                font-size: 1.1rem;
            }
        }
    }
</style>
